import amd from './amd.js';
import cjs from './cjs.js';
import es6 from './es6.js';
import iife from './iife.js';
import umd from './umd.js';

export default { amd, cjs, es6, iife, umd };
